// extracted by mini-css-extract-plugin
export default {"largeNavigation":"AIjKzKx"};